import { render, staticRenderFns } from "./DocumentDetailRow.vue?vue&type=template&id=34463c88&"
import script from "./DocumentDetailRow.vue?vue&type=script&lang=js&"
export * from "./DocumentDetailRow.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetailRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports